import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { EmployeesPage } from 'src/pages/employees';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <EmployeesPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
];

export const EMPLOYEES_ROUTE: RouteProps = {
  path: appRoutes.employees.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [
    ReactRouteAccessKey.hasEmployerRoles,
    ReactRouteAccessKey.isPeoPayrollProviderUser,
    ReactRouteAccessKey.hasPeoRoles,
    ReactRouteAccessKey.hasPlatformRoles,
    ReactRouteAccessKey.isNotPartnershipCompanyUser,
  ],
};
